import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { ThermostatSetupService } from '@app/modules/smart-devices/service/thermostat-setup.service';
import { fadeInUpAnimation } from 'src/animations';

@Component({
  selector: 'sbnb-thermostat-setup-success',
  templateUrl: './thermostat-setup-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThermostatSetupSuccessComponent implements OnInit {
  @HostBinding('class') class = 'grid h-full justify-center';

  constructor(private thermostatSetupService: ThermostatSetupService) {}

  ngOnInit() {
    this.thermostatSetupService.setThermostatPresets();
  }
}

@Component({
  selector: 'sbnb-thermostat-setup-success-wrapper',
  animations: [fadeInUpAnimation],
  template: `
    <ng-content></ng-content>
  `,
})
export class ThermostatSetupSuccessWrapperComponent {
  @HostBinding('class') class = 'grid h-full w-full max-w-2xl place-content-center';
  @HostBinding('@fadeInUpAnimation') animation = true;
}
